import {Injectable} from '@angular/core';
import {MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {MaterialModalComponent} from '@components/common/modals/material-modal/material-modal.component';
import {IServiceButtonProps} from '@shared/helpers';
import {Observable} from 'rxjs';
import { MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';

@Injectable({
  providedIn: 'root'
})

export class ModalService {
  constructor(private dialog: MatDialog) {
  }

  public openDialog(modal: any, config?: MatDialogConfig): MatDialogRef<any> {
    return this.dialog.open(modal, {
      disableClose: true,
      ...config
    });
  }

  public closeAll(): Observable<any> {
    this.dialog.closeAll();
    return this.dialog.afterAllClosed;
  }

  // todo Update props to object & add title
  // tslint:disable-next-line:typedef
  public showMsg(msg: string,
                 width: number | null = 450,
                 buttonsProps: IServiceButtonProps = {
                     cancel: false,
                     cancelTitle: 'cancel',
                     submitTitle: 'ok',
                     closePreviousModal: true
                 }) {
    if (buttonsProps.closePreviousModal) this.dialog.closeAll();
    const dialog = this.dialog.open(MaterialModalComponent, {
      width: `${width}px`,
      data: {
        msg,
        buttonsProps
      },
    });

    return dialog.afterClosed();
  }
}
